module.exports = __webpack_public_path__ + "assets/img/37_1605.3c036a9e.jpg";